'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Label;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('../../styles/scss/global.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Label(props) {
  var label = props.label,
      weight = props.weight,
      displayStyle = props.displayStyle,
      labelColor = props.labelColor;
  var styles = {
    'font-weight': weight,
    display: displayStyle
  };
  var textColor = labelColor ? ' text-' + labelColor + '-color' : '';
  return _react2.default.createElement('h2', {
    className: 'label-text' + textColor,
    style: styles
  }, label);
} // Global Style
// Core React


Label.propTypes = {
  /** Text for Label */
  label: _propTypes2.default.string.isRequired,

  /** Font weight for Label */
  weight: _propTypes2.default.string,

  /** CSS override for display */
  displayStyle: _propTypes2.default.string,

  /** Change Label Color */
  labelColor: _propTypes2.default.oneOf(['default', 'success', 'primary', 'info', 'warning', 'danger', 'black', 'white']).isRequired
};
Label.defaultProps = {
  weight: '',
  displayStyle: ''
};